import { gettext } from '@eventbrite/i18n';

// Texts with variables
export const getRefundPolicyText = (refundPolicyLink) =>
    gettext(
        'Event organizers set their own refund policies and are responsible for operating in accordance with \
        <a class="eds-btn--link eds-link" href="%(refundPolicyLink)s">Eventbrite\'s Organizer Refund Policy</a>.',
        { refundPolicyLink },
    );
export const getNewRefundPolicyText = (refundPolicyLink) =>
    gettext(
        'Event organizers are required to manage refunds in accordance with \
        <a class="eds-btn--link eds-link" href="%(refundPolicyLink)s">Eventbrite\'s Organizer Refund Policy Requirements</a>.',
        { refundPolicyLink },
    );

export const getOrganizerContactText = (organizerContactLink) =>
    gettext(
        'If an event was cancelled, and you\'ve <a class="eds-btn--link eds-link" href="%(organizerContactLink)s">contacted the organizer</a> \
        for a refund, but they declined or didn\'t respond, use this form to let us know.',
        { organizerContactLink },
    );
export const getNewOrganizerContactText = (organizerContactLink) =>
    gettext(
        'If your refund request is <a class="eds-btn--link eds-link" href="%(organizerContactLink)s">eligible</a>, \
        and the organizer has declined or not responded to your request, use this form to submit your request to Eventbrite.',
        { organizerContactLink },
    );
export const getOrderIdText = (orderIdLink) =>
    gettext(
        'The <a class="eds-btn--link eds-link" href="%(orderIdLink)s">Order ID</a> associated with your ticket',
        { orderIdLink },
    );
